module.exports = __webpack_public_path__ + "img/10_sherry_n.ff88c3d2.png";